'use strict';

export const title = 'Darkadia Studio';
export const version: string = "0.0.1";  


// WEBPACK FOOTER //
// ./src/app/global/vars.ts